import React from 'react';
import { motion } from 'framer-motion';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  className?: string;
  containerClassName?: string;
  id?: string;
  noPadding?: boolean;
}
export function Section({
  children,
  className,
  containerClassName,
  id,
  noPadding = false,
  ...props
}: SectionProps) {
  return <section id={id} className={cn('relative w-full overflow-hidden', !noPadding && 'py-16 md:py-24', className)} {...props} data-id="element-441">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className={cn('max-w-6xl mx-auto px-4 sm:px-6 lg:px-8', containerClassName)} data-id="element-442">
        {children}
      </motion.div>
    </section>;
}